import axios from 'axios';
export default (id) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .post(process.env.VUE_APP_API_ADMIN_LOCATION + `providers/performance/adjustment/reject`, {
        id: id,
      })
      .then(
        () => {
          resolve(true);
        },
        (error) => {
          reject(error);
        }
      );
  });

  return promise;
};
